<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :search.sync="query"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @cell-dblclick="cellClick"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="rentalAmount" slot-scope="{ row }">
        <el-input
          size="small"
          name="rentalAmount"
          type="number"
          placeholder="请输入内容"
          v-model="row.rentalAmount"
          autofocus
          @blur.stop="handleEdit($event, row, 53)"
          @input.native="regValidationFilter($event, row)"
          style="display: none"
        ></el-input>
        <span class="span-content" style="display: block">{{ row.rentalAmount }}</span>
      </template>
      <template slot="electricityAmount" slot-scope="{ row }">
        <el-input
          size="small"
          name="electricityAmount"
          type="number"
          v-model="row.electricityAmount"
          placeholder="请输入内容"
          autofocus
          @blur.stop="handleEdit($event, row, 52)"
          @input.native="regValidationFilter($event, row)"
          style="display: none"
        ></el-input>
        <span class="span-content" style="display: block">{{ row.electricityAmount }}</span>
      </template>
      <template slot="waterAmount" slot-scope="{ row }">
        <el-input
          size="small"
          name="waterAmount"
          type="number"
          v-model="row.waterAmount"
          placeholder="请输入内容"
          autofocus
          @blur.stop="handleEdit($event, row, 51)"
          @input.native="regValidationFilter($event, row)"
          style="display: none"
        ></el-input>
        <span class="span-content" style="display: block">{{ row.waterAmount }}</span>
      </template>
      <template slot="hygienicAmount" slot-scope="{ row }">
        <el-input
          size="small"
          name="hygienicAmount"
          type="number"
          v-model="row.hygienicAmount"
          placeholder="请输入内容"
          autofocus
          @blur.stop="handleEdit($event, row, 57)"
          @input.native="regValidationFilter($event, row)"
          style="display: none"
        ></el-input>
        <span class="span-content" style="display: block">{{ row.hygienicAmount }}</span>
      </template>
      <template slot="managementFee" slot-scope="{ row }">
        <el-input
          size="small"
          name="managementFee"
          type="number"
          v-model="row.managementFee"
          placeholder="请输入内容"
          autofocus
          @blur.stop="handleEdit($event, row, 56)"
          @input.native="regValidationFilter($event, row)"
          style="display: none"
        ></el-input>
        <span class="span-content" style="display: block">{{ row.managementFee }}</span>
      </template>
      <template slot="publicElectAmount" slot-scope="{ row }">
        <el-input
          size="small"
          name="publicElectAmount"
          type="number"
          v-model="row.publicElectAmount"
          placeholder="请输入内容"
          autofocus
          @blur.stop="handleEdit($event, row, 55)"
          @input.native="regValidationFilter($event, row)"
          style="display: none"
        ></el-input>
        <span class="span-content" style="display: block">{{ row.publicElectAmount }}</span>
      </template>
      <template slot="publicWaterAmount" slot-scope="{ row }">
        <el-input
          size="small"
          name="publicWaterAmount"
          type="number"
          v-model="row.publicWaterAmount"
          placeholder="请输入内容"
          autofocus
          @blur.stop="handleEdit($event, row, 54)"
          @input.native="regValidationFilter($event, row)"
          style="display: none"
        ></el-input>
        <span class="span-content" style="display: block">{{ row.publicWaterAmount }}</span>
      </template>
      <template slot="menuLeft">
        <el-button type="warning" size="small" icon="el-icon-plus" @click="openCollectionDialog"
          >收 款
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-s-order"
          @click="openGenerateBillDialog"
          >合并账单
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-s-order" @click="openOpenAccountDialog"
          >手动开账
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-s-order" @click="openSumRecordDialog"
        >扎 帐
        </el-button>
      </template>

      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-s-operation"
          v-if="showInvoiceApplyBtn(scope.row)"
          @click="openApplyInvioceDialog(scope.row)"
        >电子发票
        </el-button>
      </template>
      <template slot-scope="{ row }" slot="payStatus">
        <el-tag :type="row.payStatus === 1 ? 'success' : 'danger'">
          {{ setPayStatus(row.payStatus) }}</el-tag
        >
      </template>
      <template slot-scope="{ row }" slot="payType">
        <el-tag :type="danger">
          {{ setPayType(row.payType) }}
        </el-tag>
      </template>
    </avue-crud>
    <el-dialog title="收费" append-to-body :visible.sync="collectionFlag" @closed="closedDialog(1)">
      <avue-form v-model="payForm" ref="collectionRef" :option="collectionOption" @submit="paySave">
      </avue-form>
    </el-dialog>
    <el-dialog
      title="合并账单"
      append-to-body
      :visible.sync="generateBillFlag"
      @close="closedDialog(2)"
    >
      <avue-form
        v-model="generateBillForm"
        ref="generateBillFormRef"
        :option="generateBillOption"
        @submit="generateBill"
      >
      </avue-form>
    </el-dialog>
    <el-dialog
      title="手动开账"
      append-to-body
      :visible.sync="openAccountFlag"
      @close="closeOpenAccount"
    >
      <avue-form
        v-model="openAccountForm"
        ref="openAccountFormRef"
        :option="openAccountOption"
        @submit="openAccountSubmit"
      >
        <template slot="menuForm">
          <el-button @click="openRepairLogDialog">开账记录</el-button>
        </template>
      </avue-form>
    </el-dialog>
    <el-dialog
      title="扎 帐"
      append-to-body
      :visible.sync="openSumRecordFlag"
      @close="closeSumRecord"
    >
      <avue-form
        v-model="openSumRecordForm"
        ref="openSumRecordFormRef"
        :option="openSumRecordOption"
        @submit="openSumRecordSubmit"
      >
        <template slot="menuForm">
          <el-button @click="openSumRecordLogDialog">扎帐记录</el-button>
        </template>
      </avue-form>
    </el-dialog>
    <!--    开账弹窗-->
    <openAccountRecord ref="openAccountRecord"></openAccountRecord>
    <!--    扎帐弹窗-->
    <openSumRecord ref="openSumRecord"></openSumRecord>
    <!--    开票弹窗-->
    <InvoiceApplyDialog ref="invoiceApplyDialog" @submit="applyForInvoice" />
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  generate,
  lazyDepartmentPropertyTree,
  getDepartmentCommunityTree,
  updateFeeDetail,
  pay,
  getDictionaryWithIntKey,
  invoiceIssuePositive,
} from '@/api/v4ward/department/departmentfeepay';
import { mapGetters } from 'vuex';
import { openAccountRecordAdd } from '../../../api/v4ward/department/departmentacccycle';
import { openSumRecordAdd } from '../../../api/v4ward/department/reportdepartmentsumrecord';
import openAccountRecord from './open-account-record';
import openSumRecord from './open-sum-record';
import { getStore, removeStore } from '@/util/store';
import dayjs from 'dayjs';
import InvoiceApplyDialog from '../payrecord/invoice-apply-dialog';

export default {
  components: {
    openAccountRecord,
    openSumRecord,
    InvoiceApplyDialog,
},
  computed: {},
  data() {
    return {
      departmentUserInfo: {},
      tempInputValue: '',
      reWrite: false,
      form: {},
      payForm: {},
      generateBillForm: {},
      openAccountForm: {},
      openSumRecordForm: {},
      query: {
        communityId: '',
      },
      loading: true,
      collectionFlag: false,
      generateBillFlag: false,
      openAccountFlag: false,
      openSumRecordFlag: false,
      commitList: [],
      tempCommunityId: '',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      payWayList: [],
      payYesOrNoList: [],
      //主页option
      option: {
        height: 'auto',
        menuWidth: 100,
        calcHeight: 80,
        align: 'center',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: true,
        // searchMenuSpan: 6,
        addBtn: false,
        labelFixed: true,
        showHeader: true,
        columnBtn: false,
        refreshBtn: false,
        menuPosition: 'right',
        column: [
          {
            lazy: true,
            label: '小区',
            prop: 'communityId',
            type: 'select',
            search: true,
            searchSpan: 5,
            hide: true,
            clearable: false,
            dicUrl: '/api/base/property/getDepartmentCommunityTree',
            props: {
              label: 'title',
              value: 'id',
            },
          },
          {
            fixed: true,
            label: '公寓名称',
            prop: 'propertyName',
            search: true,
            searchSpan: 9,
          },
          {
            fixed: true,
            label: '租户名称',
            prop: 'renterName',
            search: true,
            searchSpan: 5,
          },
          {
            fixed: true,
            label: '账单周期',
            prop: 'billcycleNo',
            type: 'month',
            format: 'yyyyMM',
            valueFormat: 'yyyyMM',
            search: true,
            searchSpan: 5,
          },
          {
            label: '租金',
            prop: 'rentalAmount',
            slot: true,
          },
          {
            label: '电费',
            prop: 'electricityAmount',
            slot: true,
          },
          {
            label: '水费',
            prop: 'waterAmount',
            slot: true,
          },
          {
            label: '卫生费',
            prop: 'hygienicAmount',
            slot: true,
          },
          {
            label: '物业费',
            prop: 'managementFee',
            slot: true,
          },
          {
            label: '公摊电费',
            prop: 'publicElectAmount',
            slot: true,
          },
          {
            label: '公摊水费',
            prop: 'publicWaterAmount',
            slot: true,
          },
          {
            label: '应缴总额',
            prop: 'shouldAmount',
            width: 70,
          },
          {
            label: '实收总额',
            prop: 'payAmount',
          },
          {
            label: '是否支付',
            prop: 'payStatus',
            search: true,
            searchSpan: 5,
            slot: true,
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=payYesOrNo',
          },
          {
            label: '收款方式',
            prop: 'payType',
            search: true,
            searchSpan: 4,
            slot: true,
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_way',
          },
          {
            label: '押金',
            prop: 'depositAmount',
          },
          {
            label: '单位承担',
            prop: 'derateMoney',
          },
          {
            label: '银行卡号',
            prop: 'bankCardNo',
            width: 150,
          },
          {
            label: '租户类型',
            prop: 'renterType',
            type: 'select',
            search: true,
            searchSpan: 5,
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=department_rent_type',
          },
          {
            label: '租户手机',
            prop: 'renterMobile',
            width: 100,
          },
          {
            label: '开始日期',
            prop: 'payTimeStart',
            search: true,
            searchSpan: 5,
            hide: true,
            display: false,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            width: 90,
          },
          {
            label: '结束日期',
            hide: true,
            display: false,
            prop: 'payTimeEnd',
            search: true,
            searchSpan: 5,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            width: 90,
          },
        ],
      },
      //收款页面option
      collectionOption: {
        submitText: '保存',
        emptyBtn: false,
        column: [
          {
            label: '账单日期',
            prop: 'billcycleNo',
            disabled: true,
          },
          {
            label: '承租人名称',
            prop: 'renterName',
            disabled: true,
          },
          {
            label: '减免总额',
            prop: 'derateMoney',
            disabled: true,
          },
          {
            label: '应缴金额',
            prop: 'shouldAmount',
            disabled: true,
          },
          {
            label: '实付金额',
            prop: 'payAmount',
            disabled: false,
            rules: [
              {
                required: true,
                message: '实付金额不能为空',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '收款方式',
            prop: 'payType',
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_way',
            rules: [
              {
                required: true,
                message: '请选择收款方式',
                trigger: 'blur',
              },
            ],
          },
          /*{
            label: '条形码',
            prop: 'barCode',
          },*/
          {
            label: '票据号',
            prop: 'invoiceNo',
          },
        ],
      },
      //生成账单页面option
      generateBillOption: {
        align: 'center',
        addBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: '房产',
            prop: 'communityId',
            type: 'tree',
            rules: [
              {
                required: true,
                message: '请选择房产 ',
                trigger: 'blur',
              },
            ],
            props: {
              labelText: '标题',
              label: 'title',
              value: 'value',
              children: 'children',
            } /*
            treeLoad: function (node, resolve) {
              const id = node.level === 0 ? 0 : node.data.id;
              getTreeChildrenNode(id).then((res) => {
                resolve(
                  res.data.map((item) => {
                    return {
                      ...item,
                      leaf: true,
                    };
                  })
                );
              });
            },*/,
          },
          {
            label: '账单周期',
            prop: 'billcycleNo',
            type: 'month',
            format: 'yyyyMM',
            valueFormat: 'yyyyMM',
            width: 70,
            rules: [
              {
                required: true,
                message: '请选择账单周期 ',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '租户类型',
            prop: 'renterType',
            type: 'select',
            width: 70,
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=department_rent_type',
            rules: [
              {
                required: true,
                message: '请选择租户类型 ',
                trigger: 'blur',
              },
            ],
          },
        ],
      },

      //扎帐页面option
    openSumRecordOption: {
      align: 'center',
        addBtn: false,
        emptyBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
        {
          lazy: false,
          label: '扎帐小区',
          prop: 'communityId',
          type: 'tree',
          props: {
            label: 'title',
            value: 'id',
          },
          dicUrl: '/api/base/property/getDepartmentCommunityTree',
          rules: [
            {
              required: true,
              message: '请选择开账小区 ',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '开账年月',
          prop: 'accountCycle',
          type: 'datetime',
          format: 'yyyyMM',
          valueFormat: 'yyyyMM',
          disabled: true,
        },
      ],
    },
      //手动开账页面option
      openAccountOption: {
        align: 'center',
        addBtn: false,
        emptyBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
          {
            lazy: false,
            label: '开账小区',
            prop: 'communityId',
            type: 'tree',
            props: {
              label: 'title',
              value: 'id',
            },
            dicUrl: '/api/base/property/getDepartmentCommunityTree',
            rules: [
              {
                required: true,
                message: '请选择开账小区 ',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '开账年月',
            prop: 'accountCycle',
            type: 'datetime',
            format: 'yyyyMM',
            valueFormat: 'yyyyMM',
            disabled: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission', 'tagList']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.departmentfeepay_add, false),
        viewBtn: this.vaildData(this.permission.departmentfeepay_view, false),
        delBtn: this.vaildData(this.permission.departmentfeepay_delete, false),
        editBtn: this.vaildData(this.permission.departmentfeepay_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    console.log('mounted==>');
    this.initAllpayWayList();
    this.initData();
  },
  beforeRouteEnter(to, form, next) {
    next((vm) => {
      if (vm.$route.fullPath.search('fromPage') > -1) {
        //remove tag
        let tags = vm.tagList.filter(
          (ele) =>
            ele.value.search('/v4ward/department/departmentfeepay') > -1 &&
            ele.value !== vm.$route.fullPath
        );
        tags.forEach((element) => {
          vm.$store.commit('DEL_TAG', element);
        });
        //get userinfo
        vm.departmentUserInfo = getStore({ name: 'departmentUserInfo' });
        vm.departmentUserInfo.renterName = getStore({ name: 'departmentUserName' });
      } else {
        vm.departmentUserInfo = {};
        removeStore({ name: 'departmentUserInfo' });
        removeStore({ name: 'departmentUserName' });
      }
      vm.fillSearchFromAndLoadData();
    });
  },
  beforeRouteUpdate(to, from, next) {
    console.log('route update==>');
    //close tag
    const closeTag = this.$router.$avueRouter.closeTag;
    closeTag(this.$route.fullPath);
    //handle data
    if (
      to.fullPath.search('fromPage') === -1 &&
      to.fullPath.search('/v4ward/department/departmentfeepay') > -1
    ) {
      this.departmentUserInfo = {};
      removeStore({ name: 'departmentUserInfo' });
      removeStore({ name: 'departmentUserName' });
    } else {
      this.departmentUserInfo = getStore({ name: 'departmentUserInfo' });
      this.departmentUserInfo.renterName = getStore({ name: 'departmentUserName' });
    }
    this.fillSearchFromAndLoadData();
    next();
  },
  created() {
    console.log('create==>');
    //加载列表
    getDepartmentCommunityTree().then((res) => {
      this.commitList = res.data;
      if (this.commitList.length > 0) {
        this.query.communityId = this.commitList[0].id;
        this.tempCommunityId = this.commitList[0].id;
      }
      this.fillSearchFromAndLoadData();
      this.$nextTick(() => {
        this.reWrite = true;
      });
    });
  },
  methods: {
    //打开申请发票弹窗
    openApplyInvioceDialog(row) {
      console.log('row');
      console.log(row);
      this.$refs.invoiceApplyDialog.openDialog(row);
    },
    //申请发票
    applyForInvoice(data, cb) {
      let loading = this.$loading();
      invoiceIssuePositive(data)
        .then((res) => {
          loading.close();
          this.$message({
            message: res.msg,
            type: res.success ? 'success' : 'error',
          });
          cb();
          this.onLoad();
        })
        .catch((res) => {
          loading.close();
          console.log('res==>', res);
          cb();
        });
    },
    showInvoiceApplyBtn(row) {
      let notApplied = row.invoicingFlag == 0 || row.invoicingFlag == undefined || row.invoicingFlag  == '';
      let rightStatus = row.payStatus == 1;
      return notApplied && rightStatus;
    },
    fillSearchFromAndLoadData(reset = false) {
      if (this.commitList.length === 0) return;
      //当前用户是否有权限访问当前小区(?)
      let hasPermission = this.commitList.find(
        (ele) => this.departmentUserInfo.communityId == ele.id
      );
      if (!hasPermission || reset) {
        this.option.column[0].searchValue = this.commitList[0].id;
        this.query = { communityId: this.commitList[0].id };
        document.querySelector('input[placeholder="公寓名称"]').value = '';
        document.querySelector('input[placeholder="开始日期"]').value = '';
        document.querySelector('input[placeholder="结束日期"]').value = '';
        document.querySelector('input[placeholder="租户名称"]').value = '';
        document.querySelector('input[placeholder="小区"]').value = this.commitList[0].title;
      } else {
        //change keys
        let query = this.departmentUserInfo;
        query.payTimeStart = query.startDate || '';
        query.payTimeEnd = query.endDate;
        this.query = query;
        console.log('this.query==>', this.query);
        //fill form
        document.querySelector('input[placeholder="公寓名称"]').value = this.query.propertyName;
        document.querySelector('input[placeholder="开始日期"]').value = this.query.startDate
          ? dayjs(this.query.startDate).format('YYYY-MM-DD')
          : '';
        document.querySelector('input[placeholder="结束日期"]').value = this.query.endDate
          ? dayjs(this.query.endDate).format('YYYY-MM-DD')
          : '';
        document.querySelector('input[placeholder="租户名称"]').value = this.query.renterName;
        document.querySelector('input[placeholder="小区"]').value = this.commitList.find(
          (e) => e.id == this.query.communityId
        ).title;
      }
      this.onLoad();
    },
    regValidationFilter(e, row) {
      console.log(e.target);
      // console.log(parseFloat(e.target.value).toFixed(2));
      this.tempInputValue = e.target.value;
      console.log(row);
    },
    //开账弹窗
    openRepairLogDialog() {
      this.$refs.openAccountRecord.openOpenAccountRecordDialog();
    },
    //扎帐弹窗
    openSumRecordLogDialog() {
      this.$refs.openSumRecord.openOpenSumRecordDialog();
    },
    openAccountSubmit(row, done) {
      console.log(row);
      openAccountRecordAdd(row).then(
        () => {
          this.closeOpenAccount();
          let curDate = new Date();
          this.$message.success(
            '【' +
              row.$communityId +
              '】' +
              '开账任务已提交，系统将于' +
              this.dayjs(new Date(curDate.getTime() + 24 * 60 * 60 * 1000)).format('YYYY-MM-DD') +
              ' 00:05:00 生成本小区账单!'
          );
          done();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    openSumRecordSubmit(row, done) {
      console.log(row);
      openSumRecordAdd(row).then(
        () => {
          this.closeSumRecord();
          let curDate = new Date();
          this.$message.success(
            '【' +
            row.$communityId +
            '】' +
            '任务已提交，系统将于' +
            this.dayjs(new Date(curDate.getTime() + 24 * 60 * 60 * 1000)).format('YYYY-MM-DD') +
            ' 00:05:00 处理本小区数据!'
          );
          done();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    closeOpenAccount() {
      this.$refs.openAccountFormRef.resetForm();
      this.openAccountFlag = false;
    },
    closeSumRecord() {
      this.$refs.openSumRecordFormRef.resetForm();
      this.openSumRecordFlag = false;
    },
    openOpenAccountDialog() {
      this.openAccountFlag = true;
      this.openAccountForm.accountCycle = new Date();
    },
    openSumRecordDialog() {
      this.openSumRecordFlag = true;
      this.openSumRecordForm.accountCycle = new Date();
    },
    initData() {
      lazyDepartmentPropertyTree(0).then((res) => {
        const column = this.findObject(this.generateBillOption.column, 'communityId');
        column.dicData = res.data.map((item) => {
          return {
            ...item,
            leaf: true,
          };
        });
      });
    },
    initAllpayWayList() {
      getDictionaryWithIntKey('pay_way').then((data) => {
        this.payWayList = data.data;
      });
      getDictionaryWithIntKey('payYesOrNo').then((data) => {
        this.payYesOrNoList = data.data;
      });
    },
    setPayStatus(value) {
      let payTypeName = '';
      this.payYesOrNoList.forEach((s) => {
        if (s.dictKey === value) {
          payTypeName = s.dictValue;
        }
      });
      return payTypeName;
    },
    setPayType(value) {
      let payTypeName = '未支付';
      this.payWayList.forEach((s) => {
        if (s.dictKey === value) {
          payTypeName = s.dictValue;
        }
      });
      return payTypeName;
    },
    payWayNum() {
      let payWayName = '';
      this.payWayList.forEach(function (value, index, array) {
        if (value.dictValue === '现金') {
          payWayName = value.dictKey;
          return;
        }
      });
      return payWayName;
    },
    cellClick(row, column, cell, event) {
      // if(cell.className.split(' ')[0]===column.id){
      cell.querySelector('input').value = row[cell.querySelector('input').getAttribute('name')];
      cell.querySelector('.el-input').style.display = 'block';
      cell.querySelector('.span-content').style.display = 'none';
      let this_ = this;
      this_.$set(this_.data, row.$index, row, column);
      this.$nextTick(() => {
        cell.querySelector('input').focus();
        console.log(
          "cell.querySelector('input').value==>",
          cell.querySelector('input').value,
          cell.querySelector('input').getAttribute('name')
        );
        this.tempInputValue = cell.querySelector('input').value;
        this.tempInputName = cell.querySelector('input').getAttribute('name');
        this.tempSpanValue = cell.querySelector('.span-content').innerHTML;
      });
      // }

      // });
    },
    handleEdit(index, row, num) {
      // 只能修改当前月份
      let monthBillcycle = row.billcycleNo.slice(4, 6);
      let monthNow = new Date().getMonth() + 1;
      if (monthBillcycle != monthNow) {
        this.$message.error('只能调整当月账单');
        return;
      }
      //
      row.departmentSortType = num;
      let this_ = this;
      let el = event.target.parentElement.parentElement;
      el.querySelector('.el-input').querySelector('input').style.border = '';
      let reg = /^\d+(\.\d{1,2})?$/;
      // row.seen=!row.seen;
      el.querySelector('.el-input').style.display = 'none';
      el.querySelector('.span-content').style.display = 'block';

      if (row.payStatus === 1) {
        this.$message.error('不能调整已支付账单！');
        this.onLoad();
        return;
      }

      if (!this.tempInputValue) {
        this.$message.error('内容不能为空！');
        this.onLoad();
        return;
      }

      if (!reg.test(this.tempInputValue)) {
        this.$message.error('金额不能超过小数点后两位！');
        el.querySelector('.el-input').querySelector('input').style.border = '1px solid red';
        this.tempInputValue = '';
        this.onLoad();
        return;
      }

      if (Math.abs(this.tempInputValue) == Math.abs(this.tempSpanValue)) {
        this.$message.error('输入金额相同！');
        this.onLoad();
        return;
      }

      this_.loading = true;
      this_.$set(this_.data, row.$index, row);
      updateFeeDetail(row).then(
        () => {
      this_.loading = false;
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
      this_.loading = false;
          this.onLoad();
          window.console.log(error);
        }
      );
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          if (this.form.payType == -1) {
            this.form.payType = '';
          }
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.departmentUserInfo = {};
      removeStore({ name: 'departmentUserInfo' });
      removeStore({ name: 'departmentUserName' });
      const reset = true;
      this.fillSearchFromAndLoadData(reset);
    },
    searchChange(params, done) {
      this.query = { ...this.query, ...params };
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
      if (this.query.communityId == undefined || this.query.communityId == '') {
        this.query.communityId = this.tempCommunityId;
      }
      if (this.query.communityId) {
        this.query.payTimeStart = this.query.payTimeStart;
        this.query.payTimeEnd = this.query.payTimeEnd;
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          }
        );
      } else {
        this.loading = false;
      }
    },
    openCollectionDialog() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }

      let feePay = this.selectionList[0];
      if (feePay.payStatus === 1) {
        this.$message.error('该账单已经支付，请勿重复支付！');
        return;
      }

      this.payForm.id = feePay.id;
      this.payForm.billcycleNo = feePay.billcycleNo;
      this.payForm.renterName = feePay.renterName;
      this.payForm.shouldAmount = feePay.shouldAmount;
      //默认现金
      this.payForm.payType = this.payWayNum();
      this.payForm.invoiceNo = feePay.invoiceNo;
      this.payForm.derateMoney = feePay.derateMoney;
      this.payForm.payAmount = feePay.shouldAmount;
      this.collectionFlag = true;
    },
    openGenerateBillDialog() {
      this.generateBillFlag = true;
    },
    paySave(row, done) {
      pay(this.payForm).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          setTimeout(() => {
            done();
            this.collectionFlag = false;
            this.payForm = '';
          }, 2000);
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    generateBill(form, done) {
      generate(form).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.generateBillForm = {};
          this.generateBillFlag = false;
          done();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    closedDialog(flag) {
      if (flag == 1) {
        this.$refs.collectionRef.resetForm();
      }
      if (flag == 2) {
        this.$refs.generateBillFormRef.resetForm();
      }
    },
  },
};
</script>
